import React from 'react'
import { DotLottieReact } from '@lottiefiles/dotlottie-react'
import loaderAnimation from '../assets/animations/loader.lottie'

const Loader = ({ size = 64, message }) => {
  return (
    <div className="flex flex-col items-center justify-center py-8">
      <DotLottieReact
        src={loaderAnimation}
        loop
        autoplay
        speed={2}
        style={{ width: size, height: size }}
      />
      {message && <p className="mt-3 text-sm text-gray-500">{message}</p>}
    </div>
  )
}

export default Loader
